module.exports = __webpack_public_path__ + "static/media/refresh.e2d7a622.svg";